<!-- <div class="wrapper wrapper-content ng-scope animated fadeInRight">
  <div class="row error-msg">
    <div class="col-12">
      <div class="fa fa-power-off fa-5x"></div>

      <p class="message-title">{{'General.logoutMsgTitle' | translate}}</p>
      <p class="message-summary">{{'General.logoutMsgDetail' | translate}}</p>

    </div>
  </div>
</div> -->
<error-message iconClass="fa fa-power-off fa-5x" tittleKey="General.logoutMsgTitle"
  messageKey="General.logoutMsgDetail">
  <p class="font-italic m-t-md"
    [innerHTML]="translateService.instant('General.logoutMsgLink',  { 'baseUrl': this.configuration.URL_BASE})"></p>
</error-message>